<template>
  <section>
    <div class="primary-header">
      <h1 data-qa="Content-InfomationModel-Title">
        {{ componentTitle }}
        <small>{{ $route.meta.description }}</small>
      </h1>
      <el-button
        data-qa="Content-AddInfomationModel-Button"
        type="warning"
        id="btn-im-form"
        @click="addInformationModal"
      >
        {{ $t('informationModelButtonAddInfomationModelText') }}
      </el-button>
    </div>
    <el-table
      :element-loading-text="$t('informationModelTableLoadingText')"
      :data="informationModels"
      :default-sort="defaultSort"
      class="im-table"
      data-qa="Content-InformationModel-Table"
      element-loading-background="#FFFFFF"
      fit
      header-row-class-name="im-table__header"
      max-height="100%"
      show-header
      v-loading="loading"
    >
      <el-table-column :label="$t('informationModelTableColFamilyNameLabel')" prop="index" sortable min-width="120"></el-table-column>
      <el-table-column :label="$t('informationModelTableColFileNameLabel')" prop="name" min-width="200"></el-table-column>
      <el-table-column :label="$t('informationModelTableColModelImageLabel')" prop="informationModel" min-width="130">
        <template slot-scope="scope">
          <el-button
            @click.prevent="showSetImagePopup(scope.row.informationModel, false)"
            :data-qa="`Content-InformationModel-UploadImages-${scope.row.index}`"
            size="medium"
            v-if="hasNoImages(scope.row.informationModel)"
          >
            {{ $t('informationModelButtonUploadImagesText') }}
          </el-button>
          <div class="edit-image" v-else>
            <img
              :src="getImageSrc(scope.row.informationModel)"
              height="34"
              v-if="getImageSrc(scope.row.informationModel)"
            />
            <el-button
              @click.prevent="showSetImagePopup(scope.row.informationModel, true)"
              :data-qa="`Content-InformationModel-EditImages-${scope.row.index}`"
              size="medium"
            >
              {{ $t('informationModelButtonEditImagesText') }}
            </el-button>
          </div>
        </template>
      </el-table-column>
      <el-table-column :label="$t('informationModelTableColLastModifiedLabel')" prop="timestamp" sortable min-width="140">
        <template slot-scope="scope">
          <div>{{ scope.row.formatedDate | formatDate }}</div>
        </template>
      </el-table-column>
      <el-table-column :label="$t('informationModelTableColActionLabel')" fixed="right" min-width="60">
        <template slot-scope="scope">
          <el-tooltip effect="dark" :content="$t('informationModelTooltipDownloadText')" placement="top-start">
            <a
              :data-qa="`Content-DownloadInformationModel-Button-${scope.row.index}`"
              :download="scope.row.name"
              :href="scope.row.downloadLink"
              target="_blank"
              class="el-button el-button--mini el-button--text"
            >
              <i class="fa fa-download fa-2 operation-icons"></i>
            </a>
          </el-tooltip>
          <el-tooltip effect="dark" :content="$t('informationModelTooltipDeleteText')" placement="top-start">
            <el-button
              :data-qa="'Content-DeleteInformationModel-Button-' + scope.row.index"
              @click="removeInformationModel(scope.row.index)"
              size="mini"
              type="text"
            >
              <i class="fa fa-trash fa-2 operation-icons"></i>
            </el-button>
          </el-tooltip>
        </template>
      </el-table-column>
    </el-table>
    <information-model-delete></information-model-delete>
    <information-model-images-upload></information-model-images-upload>
    <information-model-upload></information-model-upload>
  </section>
</template>

<script>
  import main from './InformationModel.js'
  export default main
</script>

<style lang="scss" scoped>
  @import './InformationModel.scss'
</style>



// WEBPACK FOOTER //
// InformationModel.vue?5ff55277